module.exports = __webpack_public_path__ + "static/media/Gallary6.f14bc16e.webp";